/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetBanners200ResponseBannersInner } from './GetBanners200ResponseBannersInner';
import {
    GetBanners200ResponseBannersInnerFromJSON,
    GetBanners200ResponseBannersInnerFromJSONTyped,
    GetBanners200ResponseBannersInnerToJSON,
} from './GetBanners200ResponseBannersInner';

/**
 * 
 * @export
 * @interface GetBanners200Response
 */
export interface GetBanners200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof GetBanners200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof GetBanners200Response
     */
    message: string;
    /**
     * 
     * @type {Array<GetBanners200ResponseBannersInner>}
     * @memberof GetBanners200Response
     */
    banners: Array<GetBanners200ResponseBannersInner>;
}

/**
 * Check if a given object implements the GetBanners200Response interface.
 */
export function instanceOfGetBanners200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "banners" in value;

    return isInstance;
}

export function GetBanners200ResponseFromJSON(json: any): GetBanners200Response {
    return GetBanners200ResponseFromJSONTyped(json, false);
}

export function GetBanners200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBanners200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'banners': ((json['banners'] as Array<any>).map(GetBanners200ResponseBannersInnerFromJSON)),
    };
}

export function GetBanners200ResponseToJSON(value?: GetBanners200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'banners': ((value.banners as Array<any>).map(GetBanners200ResponseBannersInnerToJSON)),
    };
}

